import React from 'react';
import styles from './Table.module.css';

export interface TableBodyProps {
  children: React.ReactNode;
  className?: string;
}

const TableBody: React.FC<TableBodyProps> = ({ children, className = '' }) => {
  return (
    <div className={`${styles.tableBody} ${className}`}>
      {children}
    </div>
  );
};

export default TableBody;

